import { lazy } from 'react';

export * from './MenuButton';
export * from './Title';
export * from './HeaderSection';
export * from './EvnToggler';
export * from './BeetleBreadcrumbs';
export * from './styles';
export * from './hooks';
export * from './TooltipWithPopover';
export * from './Navbar';

export const LazyUserPayments = lazy(() =>
  import(/* webpackChunkName: "Payments" */ './UserPayments').then((module) => ({
    default: module.UserPayments,
  }))
);
